import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { percentOf } from '../../SplitProgressBarChart/util';

type Props = {
  title: string;
  completed: number;
  assigned: number;
  total: number;
};

const LessonProgressBar: React.FC<Props> = ({ title, completed, total, assigned }) => {
  const classes = useStyles({ completed, total, assigned });

  return (
    <Box className={classes.base}>
      <Box display="flex" justifyContent="space-between">
        <Typography className={classes.text}>{title}</Typography>
        <Typography className={classes.text}>
          <span style={{ fontWeight: 450 }}>{completed}</span> of {total}
        </Typography>
      </Box>
      <div className={classes.bar} title={`Total: ${total}`}>
        <div className={classes.assigned} title={`Assigned: ${assigned}`} />
        <div className={classes.completed} title={`Completed: ${completed}`} />
      </div>
    </Box>
  );
};

const buildPercent = (value: number) => `${value}%`;
const colors = {
  assigned: 'rgba(51, 138, 198, 0.4)',
  completed: '#338AC6',
  total: '#F4F4F4'
};
const useStyles = makeStyles(() => ({
  base: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  bar: {
    display: 'flex',
    height: 12,
    borderRadius: 8,
    width: '100%',
    backgroundColor: colors.total
  },
  text: {
    fontSize: 18,
    fontWeight: 400
  },
  assigned: ({ assigned, total }: Omit<Props, 'title'>) => ({
    backgroundColor: colors.assigned,
    width: buildPercent(percentOf(assigned, total)),
    borderRadius: 8
  }),
  completed: ({ completed, total, assigned }: Omit<Props, 'title'>) => ({
    backgroundColor: colors.completed,
    width: buildPercent(percentOf(completed, total)),

    borderRadius: 8,
    marginLeft: `-${buildPercent(percentOf(assigned, total))}`
  }),
  total: {
    backgroundColor: colors.total,
    width: '100%',
    borderBottomRightRadius: 8,
    borderTopRightRadius: 8
  }
}));

export default LessonProgressBar;
